/**
 * Redux reducer for publishing dialog.
 * @module redux/reducers/publish
 */

import { RECEIVED_CONTEXTS } from "../actions/assets";
import {
  ASSET_TYPE_CHANGED,
  CATEGORY_CHANGED,
  CONTEXT_CHANGED,
  FOLDER_CHANGED,
  RECEIVED_CATEGORIES,
  RECEIVED_FOLDERS,
  RECEIVED_RENDER_MEDIA_DESTINATIONS,
  RENDER_MEDIA_DESTINATION_CHANGED,
  WITH_PREVIEW_ONLY_IMAGES_CHANGED
} from "./../actions/publish";
import ASSET_TYPE from "../constants/publishingAssetTypes";

const initialState = {
  assetType: ASSET_TYPE.movie.toLowerCase(),
  categoryIds: [],
  categoryList: [],
  contextId: -1,
  contextList: [],
  destinationId: "",
  destinationList: [],
  folderId: -1,
  folderList: [],
  withPreviewOnlyImages: true
};

const ACTION_HANDLERS = {
  [ASSET_TYPE_CHANGED]: (state, action) => ({
    ...state,
    assetType: action.payload.assetType
  }),
  [CATEGORY_CHANGED]: (state, action) => ({
    ...state,
    categoryIds: action.payload.categoryIds
  }),
  [CONTEXT_CHANGED]: (state, action) => ({
    ...state,
    contextId: action.payload.contextId
  }),
  [FOLDER_CHANGED]: (state, action) => ({
    ...state,
    folderId: action.payload.folderId
  }),
  [RECEIVED_CATEGORIES]: (state, action) => {
    const { categoryList } = action.payload;
    return {
      ...state,
      categoryList:
        categoryList && categoryList.length > 0
          ? categoryList[0].categories
          : []
    };
  },
  [RECEIVED_CONTEXTS]: (state, action) => ({
    ...state,
    contextList: action.payload.contextList
  }),
  [RECEIVED_FOLDERS]: (state, action) => {
    const realFolders = generateFolderPaths(action.payload.folderList).sort(
      comparePath
    );
    return {
      ...state,
      folderList: realFolders
    };
  },
  [RECEIVED_RENDER_MEDIA_DESTINATIONS]: (state, action) => {
    const destinations = action.payload.destinations;
    if (destinations != null && destinations.length > 0) {
      const validDestinations = destinations.filter(d => d.isValid);
      const defaultDestination =
        validDestinations.length > 0 ? validDestinations[0] : "";
      return {
        ...state,
        destinationId: defaultDestination.id.toString(),
        destinationList: destinations
      };
    }
  },
  [RENDER_MEDIA_DESTINATION_CHANGED]: (state, action) => ({
    ...state,
    destinationId: action.payload.destinationId
  }),
  [WITH_PREVIEW_ONLY_IMAGES_CHANGED]: (state, action) => ({
    ...state,
    withPreviewOnlyImages: action.payload.withPreviewOnlyImages === "true"
  })
};

export default function publish(state = initialState, action) {
  const handler = ACTION_HANDLERS[action.type];

  return handler ? handler(state, action) : state;
}

const comparePath = (a, b) => {
  if (a.path < b.path) {
    return -1;
  }

  if (a.path > b.path) {
    return 1;
  }

  return 0;
};

const generateFolderPath = (initialFolders, currentFolder) => {
  if (currentFolder.parentId === 0) {
    return "/";
  }

  let filePath = `/${currentFolder.name}`;
  let parentFolder = initialFolders.find(f => f.id === currentFolder.parentId);
  while (parentFolder.parentId !== 0) {
    filePath = `/${parentFolder.name}${filePath}`;
    // eslint-disable-next-line
    parentFolder = initialFolders.find(f => f.id === parentFolder.parentId);
  }

  return filePath;
};

const generateFolderPaths = initialFolders =>
  initialFolders.map(f => ({
    ...f,
    path: generateFolderPath(initialFolders, f)
  }));



// WEBPACK FOOTER //
// ./app/reducers/publish.js